import { useLocation } from 'react-router-dom';

interface QueryStringProps {
  query: string;
}

export function useQueryStringNumber({
  query
}: QueryStringProps): number | null {
  const result = useQueryStringText({ query });
  const id = result ? Number.parseInt(result, 10) : null;

  return id;
}

export function useQueryStringText({ query }: QueryStringProps): string | null {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const result = searchParams.get(query);

  return result;
}
